/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_BodyInputs */



/**
* | output |
* | --- |
* | "Under Practice you'll find this week's practice conversation. Every week you get an email to try out a new one." |
*
* @param {Onboarding_Pilot_Ready_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_body = /** @type {((inputs?: Onboarding_Pilot_Ready_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Onder Oefenen vind je het oefengesprek van deze week. Elke week krijg je een mail om een nieuw oefengesprek uit te proberen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous S'entraîner, vous trouvez l’entretien d’entraînement de cette semaine. Chaque semaine, vous recevez un e-mail pour en essayer un nouveau.")
	return /** @type {LocalizedString} */ ("Under Practice you'll find this week's practice conversation. Every week you get an email to try out a new one.")
});